import ApiCrud from "./api-crud";

class PagoCategoriaService extends ApiCrud {
  resource = "pago_categorias";
  primaryKey = "idpago_categoria";
}

export default new PagoCategoriaService();
